import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import List from "../../components/List/List";
import Divider from '../../components/Divider/Divider'
import Title from "../../components/Title/Title";


const Palette = () => {
  return (
    <div className="container py-4">
        <div className="row">
            <div className="col-12 col-md-12">
                <Title weight={800}>MULTI-POINT AUTOMATION, 2025 (Q1)</Title>
                <p> Automation was treated as a binary decision: once a entity exited the automation funnel, it defaulted to manual processing, even as new information reduced uncertainty. This limited automation value and concentrated operational effort on work that was no longer genuinely complex.</p>
                <Divider/>
            </div>
            <div className="col-12 col-md-6">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <Title weight={800}>PRODUCT DIRECTION</Title>
                        <p> Reframe automation as a progressive capability rather than a single pass/fail gate. Allow the re-entry of entities into the automation funnel at various points, enabling the release of partial automation value across the process.</p>
                    </div>
                    <div className="col-12 col-md-12">
                        <Title weight={800}>TRADE-OFFS</Title>
                        <List
                            items={[
                                { label: "Higher automation volume accepted in exchange for increased financial exposure" },
                                { label: "Longer processing paths for entities that repeatedly fail automated re-entry" },
                                { label: "Additional operational effort as work exits automation at multiple stages" },
                                { label: "Increased complexity in quality assurance and reporting" },
                            ]}
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-3">
                <Title weight={800} highlight>IMPACT</Title>
                <List items={[
                     { label: "~6% increase in automation volume" },
                        { label: "~2,000 additional automated entities per month" },
                        { label: "600+ hours of efficiency per month" },
                     { label: "Strategic enabler for future leverage" },
                ]}/>
            </div>
            <div className="col-12 col-md-3">
                <Title weight={800}>CROSS-FUNCTIONAL SCOPE</Title>
                <List items={[
                     { label: "Design" },
                     { label: "Back-end / Front-end" },
                     { label: "Data platform" },
                     { label: "Operations" },
                     { label: "Underwriting" },
                     { label: "Legal / Compliance" },
                ]}/>
            </div>
        </div>
        <Divider/>
    </div>
  );
};

export default Palette;
